import { formatCSV } from './format-csv.js';
import { isValidDatapointForDownload } from './validation-datapoint.js';
import { downloadCSV } from '../../../core/utils/download.js';
import { CSS_DOWNLOAD_FILENAME } from '../../core/constants.js';
import {
  type SeriesToMetadata,
  type MapDatapoints,
  type XYChartSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';

export const getSeriesName = (metadata: SeriesToMetadata) => {
  return (series: XYChartSeriesWithDatapoints) => {
    return metadata.get(series)?.name;
  };
};

/**
 * XYChart data and downloads the file.
 * @param data - XYChart series with data points
 * @returns void
 */
export const buildAndDownloadCsv = (
  data: XYChartSeriesWithDatapoints[],
  seriesMetadata: SeriesToMetadata,
  datapointMetadata: MapDatapoints,
  downloadDataCallback?: () => void,
) => {
  if (downloadDataCallback) {
    downloadDataCallback();
  } else {
    const csvString = formatCSV(
      data,
      isValidDatapointForDownload(datapointMetadata),
      getSeriesName(seriesMetadata),
    );
    downloadCSV(csvString, CSS_DOWNLOAD_FILENAME);
  }
};
